var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFilledGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#299B0A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51664 4.14656C9.61038 4.24032 9.66304 4.36748 9.66304 4.50006C9.66304 4.63264 9.61038 4.7598 9.51664 4.85356L5.76898 8.60123C5.71945 8.65076 5.66065 8.69006 5.59594 8.71687C5.53122 8.74368 5.46186 8.75748 5.39181 8.75748C5.32176 8.75748 5.2524 8.74368 5.18769 8.71687C5.12297 8.69006 5.06417 8.65076 5.01464 8.60123L3.15264 6.73956C3.10489 6.69344 3.0668 6.63826 3.04059 6.57726C3.01439 6.51626 3.0006 6.45065 3.00002 6.38426C2.99944 6.31787 3.01209 6.25203 3.03723 6.19058C3.06237 6.12913 3.0995 6.07331 3.14645 6.02636C3.19339 5.97942 3.24922 5.94229 3.31067 5.91715C3.37212 5.89201 3.43796 5.87936 3.50434 5.87993C3.57073 5.88051 3.63634 5.8943 3.69735 5.92051C3.75835 5.94671 3.81352 5.9848 3.85964 6.03256L5.39164 7.56456L8.80931 4.14656C8.85574 4.1001 8.91088 4.06324 8.97156 4.03809C9.03225 4.01294 9.09729 4 9.16298 4C9.22867 4 9.29371 4.01294 9.35439 4.03809C9.41508 4.06324 9.47021 4.1001 9.51664 4.14656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilledGreenIcon);
export default __webpack_public_path__ + "static/media/check-filled-green-icon.fdc12394e7d60e096eb6b41bd0f8eeb2.svg";
export { ForwardRef as ReactComponent };